import { observer } from 'mobx-react-lite'
import { EmptyState, type IRow, Table, variantActionsProps } from 'shared/ui'
import { type IKeyword } from 'entities/Keywords'
import { KeywordsRoutes } from 'pages/keywords'
import { useKeywordsListContext } from 'pages/keywords/context'
import { columns } from './columns'
import { getKeywordActions } from './getKeywordActions'
import { DeleteAction } from './TableActions'
import styles from './styles.module.scss'

export const KeywordsTable = observer(() => {
  const {
    limit,
    page,
    isLoading,
    total,
    keywords,
    tableStore,
    onPaginationModelChange,
    isNoSearchResults,
    onDelete,
  } = useKeywordsListContext()

  const getRows = () => {
    return keywords.map((keyword) => {
      keyword.setActionsProps({
        ...variantActionsProps.table,
        actions: getKeywordActions({
          keyword: keyword,
          onSuccessDelete: () => onDelete(keyword.id),
        }),
      })

      return keyword
    })
  }

  const getRowLink = (row: IRow<IKeyword>) =>
    `/${KeywordsRoutes.root}/${KeywordsRoutes.view}/${row.id}`

  if (isNoSearchResults) {
    return <EmptyState text='No keywords found' />
  }

  return (
    <div className={styles.wrap}>
      <Table
        ariaLabel={'KeywordsTable'}
        withCheckbox
        headerLeftContentProps={{
          actionsContent: <DeleteAction />,
        }}
        store={tableStore}
        columns={columns}
        pinnedColumnNames={['name']}
        rows={getRows()}
        getRowLink={getRowLink}
        rowsCount={total}
        isLoading={isLoading}
        onChangePagination={onPaginationModelChange}
        initPage={page}
        limit={limit}
        sortBy={tableStore.sortBy}
        startPaginationSize={10}
        virtualization
      />
    </div>
  )
})
